import { SlideNumber } from '../../atoms/SlideNumber';
import { NextSlideButton } from '../NextSlideButton';
import { PrevSlideButton } from '../PrevSlideButton';

export const BroadcasterPresentationSlideNavigator = ({ goToPrevSlide, goToNextSlide, totalSlides, localCurrentSlideNumber }: any) => (
    <div className="flex-none bg-black/20 rounded-lg text-white flex gap-1 p-2">
        <PrevSlideButton
            classNames={`bg-primary/80 rounded-l-md rounded-r-s ${localCurrentSlideNumber === 0 && 'btn-disabled'}`}
            onClick={goToPrevSlide}
            disabled={localCurrentSlideNumber === 0}
        />
        <SlideNumber currentSlideNumber={localCurrentSlideNumber + 1} totalSlides={totalSlides} />
        <NextSlideButton
            classNames={`bg-primary/80 rounded-r-md rounded-l-s ${localCurrentSlideNumber === totalSlides - 1 && 'btn-disabled'}`}
            onClick={goToNextSlide}
            disabled={localCurrentSlideNumber === totalSlides - 1}
        />
    </div>
);
